import type { Components, Theme } from '@mui/material/styles'

export const MuiOutlinedInputOverride: Components<Theme>['MuiOutlinedInput'] = {
  styleOverrides: {
    // MUI ships a dark-mode autofill treatment on the input slot that repaints the
    // field a fixed blue. Under `cssVariables: true` with a single color scheme its
    // dark-mode selector collapses to `&`, so it applies in light mode too. Cancel
    // it, and hold off the browser's own autofill repaint indefinitely, so an
    // autofilled field keeps the surface it is sitting on in both modes.
    input: {
      '&:-webkit-autofill': {
        WebkitBoxShadow: 'none',
        WebkitTextFillColor: 'inherit',
        caretColor: 'inherit',
        transition: 'background-color 600000s 0s, color 600000s 0s',
      },
    },
  },
}
